import {SelectItem} from 'primeng/api';

/**
 * Classe auxiliar para transformação de enums em SelectItem
 */
export class SelectItemHelper {
  /*
     * Cache simples, mantém os objetos na memória por uma hora, a primeira chamada após a expiração limpa o cache inteiro.
     * Talvez seja necessário utilizar uma estratégia mais eficiente
     */
  private static cache: Map<object, SelectItem[]> = new Map<object, SelectItem[]>();
  private static cacheTimeout: number;

  /**
   * Recupera todas as chaves dos enums indiferente da tipagem
   * @param tipo - tipo do enum
   */
  private static chaves(tipo: object) {
    const membros = Object.keys(tipo);
    let chaves: string[];
    if (!SelectItemHelper.isNumeral(tipo)) {
      chaves = membros;
    }
    else {
      chaves = [];
      membros.forEach((chave) => {
        const chaveConvertida = parseInt(chave, 10);
        if (Number.isNaN(chaveConvertida)) {
          chaves.push(chave);
        }
      });
    }
    return chaves.filter((x) => Number.isNaN(parseInt(x, 10)));
  }

  private static isNumeral(enumType: object) {
    const members = Object.keys(enumType);
    if (!members.some(() => true)) {
      throw new TypeError('Tipo de enum inválido.');
    }
    let parsedCount = 0;
    members.forEach((x) => {
      const parsedValue = parseInt(x, 10);
      if (!Number.isNaN(parsedValue)) {
        parsedCount++;
      }
    });
    return parsedCount === members.length / 2;
  }

  /**
   * Transforma o Enum em SelectItem
   * @param tipo - tipo do enum
   */
  public static enumToSelectItem(tipo: object): any[] {
    if (this.isCacheExpirado()) {
      this.cache = new Map<object, SelectItem[]>();
      this.cacheTimeout = Date.now() + (3600000);
    }
    if (!this.cache.has(tipo)) {
      const items = SelectItemHelper.chaves(tipo)
        .map((chave) => {
          return {label: tipo[chave], value: chave};
        });
      this.cache.set(tipo, items);
    }
    return this.cache.get(tipo);
  }

  public static getDescricao(tipo: object, chave: any) {
    return tipo[chave];
  }

  public static getLabelSI(selectItems: SelectItem [], chave: any) {
    return selectItems.find(si => si.value === chave).label;
  }

  private static isCacheExpirado(): boolean {
    return Date.now() > SelectItemHelper.cacheTimeout;
  }

}
